// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/common.scss
// module id = ./resources/assets/sass/common.scss
// module chunks = 0